module.exports = __webpack_public_path__ + "6b8667565e245c830f3bd93fd3090ab2.png";